import { render, staticRenderFns } from "./TargetFinihsed.vue?vue&type=template&id=21c4eddd"
import script from "./TargetFinihsed.vue?vue&type=script&lang=js"
export * from "./TargetFinihsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports